module.exports = __webpack_public_path__ + "img/amex.a4aaac45.svg";